export default "__VITE_ASSET__2ff757c9__"